import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ReferralProgram from "../pages/referral/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/referral-program",
    element: <ReferralProgram />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
